/**
 * Share utilities for Wordle 6 7
 */

const EMOJI_MAP = {
  correct: '🟩',
  present: '🟨',
  absent: '⬛'
};

/**
 * Generate share text from game results
 * @param {number} gameNumber - The game number
 * @param {Array<Array<string>>} evaluations - Array of evaluation arrays
 * @param {boolean} won - Whether the player won
 * @param {number} guessCount - Number of guesses used
 * @returns {string} Share text with emoji grid
 */
export function generateShareText(gameNumber, evaluations, won, guessCount) {
  // Title line
  const result = won ? `${guessCount}/7` : 'X/7';
  let shareText = `Wordle 6 7 #${gameNumber} ${result}\n\n`;

  // Add emoji grid for each guess
  evaluations.forEach(evaluation => {
    const row = evaluation.map(status => EMOJI_MAP[status] || '⬛').join('');
    shareText += row + '\n';
  });

  // Add domain
  shareText += '\nwordle67.com';

  return shareText;
}

/**
 * Copy text to clipboard
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} Success status
 */
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textArea);
      return success;
    }
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
}